<div class="teams-container">
  <div class="teams-header">
    <div>
      <h2><i class="fa-solid fa-users-rectangle"></i> Ticket Teams</h2>
      <p class="teams-sub">Groups of agents that tickets are routed to. Members carry a role, availability, and ticket capacity.</p>
    </div>
    <button class="btn-primary" (click)="startCreateTeam()" *ngIf="!isCreatingTeam">
      <i class="fa-solid fa-plus"></i> New Team
    </button>
  </div>

  <div class="banner banner-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="banner banner-success" *ngIf="successMessage">{{ successMessage }}</div>

  <!-- Create team -->
  <div class="create-card" *ngIf="isCreatingTeam">
    <input type="text" placeholder="Team name" [(ngModel)]="newTeamName" class="text-input" />
    <input type="text" placeholder="Description (optional)" [(ngModel)]="newTeamDescription" class="text-input" />
    <div class="create-actions">
      <button class="btn-primary" (click)="saveCreateTeam()" [disabled]="isSaving">Create</button>
      <button class="btn-ghost" (click)="cancelCreateTeam()">Cancel</button>
    </div>
  </div>

  <div class="teams-loading" *ngIf="isLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading teams…</div>

  <div class="teams-empty" *ngIf="!isLoading && teams.length === 0 && !isCreatingTeam">
    <i class="fa-solid fa-users-rectangle"></i>
    <p>No teams yet. Create one to start routing tickets.</p>
  </div>

  <!-- Team list -->
  <div class="team-card" *ngFor="let t of teams">
    <div class="team-row">
      <button class="expand-btn" (click)="toggleExpand(t)">
        <i class="fa-solid" [class.fa-chevron-right]="!t.isExpanded" [class.fa-chevron-down]="t.isExpanded"></i>
      </button>

      <ng-container *ngIf="!t.isEditing">
        <div class="team-main">
          <span class="team-name">{{ t.team.Name }}</span>
          <span class="team-desc" *ngIf="t.team.Description">{{ t.team.Description }}</span>
        </div>
        <span class="team-count">{{ t.members.length }} member{{ t.members.length === 1 ? '' : 's' }}</span>
        <span class="status-chip" [class.inactive]="t.team.Status !== 'Active'">{{ t.team.Status }}</span>
        <div class="team-actions">
          <button class="icon-btn" title="Edit" (click)="startEditTeam(t)"><i class="fa-solid fa-pen"></i></button>
          <button class="icon-btn" [title]="t.team.Status === 'Active' ? 'Deactivate' : 'Activate'" (click)="toggleTeamStatus(t)">
            <i class="fa-solid" [class.fa-toggle-on]="t.team.Status === 'Active'" [class.fa-toggle-off]="t.team.Status !== 'Active'"></i>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="t.isEditing">
        <input type="text" [(ngModel)]="t.editName" class="text-input" />
        <input type="text" [(ngModel)]="t.editDescription" placeholder="Description" class="text-input" />
        <div class="team-actions">
          <button class="btn-primary" (click)="saveEditTeam(t)" [disabled]="isSaving">Save</button>
          <button class="btn-ghost" (click)="cancelEditTeam(t)">Cancel</button>
        </div>
      </ng-container>
    </div>

    <!-- Members -->
    <div class="members" *ngIf="t.isExpanded">
      <div class="member-row member-head">
        <span>Member</span><span>Role</span><span>Available</span><span>Max tickets</span><span></span>
      </div>

      <div class="member-row" *ngFor="let m of t.members">
        <span class="member-name">{{ m.personName }}</span>
        <select [(ngModel)]="m.member.Role" (change)="saveMember(m)" class="sel">
          <option value="Lead">Lead</option>
          <option value="Member">Member</option>
        </select>
        <label class="avail">
          <input type="checkbox" [(ngModel)]="m.member.IsAvailable" (change)="saveMember(m)" />
        </label>
        <input type="number" min="0" [(ngModel)]="m.member.MaxConcurrentTickets" (change)="saveMember(m)"
               placeholder="∞" class="num-input" />
        <button class="icon-btn danger" title="Remove" (click)="removeMember(t, m)"><i class="fa-solid fa-trash"></i></button>
      </div>

      <div class="member-empty" *ngIf="t.members.length === 0">No members yet.</div>

      <!-- Add member -->
      <div class="add-member">
        <select [(ngModel)]="addMemberPersonId[t.team.ID]" class="sel grow">
          <option value="">Add a member…</option>
          <option *ngFor="let p of availablePeople(t)" [value]="p.ID">{{ personName(p.ID) }}</option>
        </select>
        <button class="btn-secondary" (click)="addMember(t)" [disabled]="!addMemberPersonId[t.team.ID] || isSaving">
          <i class="fa-solid fa-user-plus"></i> Add
        </button>
      </div>
    </div>
  </div>
</div>
